import { FoundationElement } from '@microsoft/fast-foundation';
import { ChameleonElementMixin } from '../../common/mixin';
export class MenuSectionComponent extends ChameleonElementMixin(FoundationElement) {
}
